(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6251,9956],{

/***/ 83764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30730);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_badge_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53218);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69626);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93587);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67330);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__);







function Badge(param) {
    let { type , variant ="default" , size ="medium"  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    switch(type){
        case "bonus":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bonus), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("bonus")
                    })
                ]
            });
        case "discount":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().discount), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                    size: 20
                })
            });
        case "popular":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().popular), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("popular")
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {});
    }
}


/***/ }),

/***/ 791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42041);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88700);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function PrimaryButton(param) {
    let { children , disabled , onClick , type ="button" , icon , loading =false , size ="medium" , id , fullWidth =true , rounded =true , danger =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        id: id,
        type: type,
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().primaryBtn), " ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[size], " ").concat(disabled ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : "", " ").concat(fullWidth ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullWidth) : "", " ").concat(rounded ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rounded) : "", " ").concat(danger ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().danger) : ""),
        disabled: disabled || loading,
        onClick: onClick,
        children: !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                icon ? icon : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
                    children: children
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: 22
        })
    });
}


/***/ }),

/***/ 9956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Empty; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55684);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_empty_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_button_primaryButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(791);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21867);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable @next/next/no-img-element */ 




function Empty(param) {
    let { text , buttonText , link ="/"  } = param;
    const { push  } = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/images/delivery.webp",
                    alt: "Empty"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                    children: text
                }),
                !!buttonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().actions),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_button_primaryButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: ()=>push(link),
                        children: buttonText
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 25627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FallbackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79963);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86430);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable @next/next/no-img-element */ 



function FallbackImage(param) {
    let { src , alt ="image" , onError , style , fill , width , height , ...props } = param;
    const isValidSrc = src && (src.startsWith("/") || src.startsWith("http://") || src.startsWith("https://"));
    if (!isValidSrc) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        ...props,
        style: style,
        src: src,
        alt: alt,
        title: alt,
        fill: fill,
        width: width,
        height: height,
        className: (_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default().root),
        onError: (e)=>{
            e.target.style.visibility = "hidden";
            onError === null || onError === void 0 ? void 0 : onError(e);
        }
    });
}


/***/ }),

/***/ 85794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ WEEK; }
/* harmony export */ });
const WEEK = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday"
];


/***/ }),

/***/ 95051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ShopList; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./containers/shopList/shopList.module.scss
var shopList_module = __webpack_require__(88090);
var shopList_module_default = /*#__PURE__*/__webpack_require__.n(shopList_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+system@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+styled@_oja7ubotzrzctrclxreoqqilcu/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(9120);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(53048);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(52709);
// EXTERNAL MODULE: ./components/shopCard/shopCard.module.scss
var shopCard_module = __webpack_require__(79059);
var shopCard_module_default = /*#__PURE__*/__webpack_require__.n(shopCard_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(6339);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/shopLogo/shopLogo.module.scss
var shopLogo_module = __webpack_require__(66944);
var shopLogo_module_default = /*#__PURE__*/__webpack_require__.n(shopLogo_module);
// EXTERNAL MODULE: ./utils/getImage.ts
var getImage = __webpack_require__(7592);
// EXTERNAL MODULE: ./components/fallbackImage/fallbackImage.tsx
var fallbackImage = __webpack_require__(25627);
;// CONCATENATED MODULE: ./components/shopLogo/shopLogo.tsx





function ShopLogo(param) {
    let { data  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (shopLogo_module_default()).logo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
            fill: true,
            src: (0,getImage/* default */.Z)(data.logo_img),
            alt: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
            sizes: "60px",
            quality: 90
        })
    });
}

// EXTERNAL MODULE: ./containers/shopBadges/shopBadges.module.scss
var shopBadges_module = __webpack_require__(97950);
var shopBadges_module_default = /*#__PURE__*/__webpack_require__.n(shopBadges_module);
// EXTERNAL MODULE: ./components/badge/badge.tsx
var badge = __webpack_require__(83764);
;// CONCATENATED MODULE: ./containers/shopBadges/shopBadges.tsx




function ShopBadges(param) {
    let { data  } = param;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (shopBadges_module_default()).badge,
        children: [
            data.is_recommended && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "popular",
                variant: !!((ref = data.discount) === null || ref === void 0 ? void 0 : ref.length) || !!data.bonus ? "circle" : "default",
                size: "large"
            }),
            !!((ref1 = data.discount) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "discount",
                variant: data.is_recommended || !!data.bonus ? "circle" : "default",
                size: "large"
            }),
            !!data.bonus && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "bonus",
                variant: data.is_recommended || !!((ref2 = data.discount) === null || ref2 === void 0 ? void 0 : ref2.length) ? "circle" : "default",
                size: "large"
            })
        ]
    });
}

// EXTERNAL MODULE: ./hooks/useLocale.tsx
var useLocale = __webpack_require__(46405);
// EXTERNAL MODULE: ./hooks/useShopWorkingSchedule.tsx
var useShopWorkingSchedule = __webpack_require__(40079);
// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(17312);
;// CONCATENATED MODULE: ./components/verifiedComponent/verifiedComponent.tsx


function VerifiedComponent() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        style: {
            display: "block",
            minWidth: "16px",
            height: "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* VerifiedIcon */.SA, {})
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Rating/Rating.js + 4 modules
var Rating = __webpack_require__(54017);
;// CONCATENATED MODULE: ./components/shopCard/shopCard.tsx











function ShopCard(param) {
    let { data  } = param;
    var ref, ref1;
    const { t  } = (0,useLocale/* default */.Z)();
    const { isShopClosed , workingSchedule  } = (0,useShopWorkingSchedule/* default */.Z)(data);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: "/shop/".concat(data.id),
        className: "".concat((shopCard_module_default()).wrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shopCard_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                    fill: true,
                    src: (0,getImage/* default */.Z)(data.background_img),
                    alt: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                    sizes: "400px",
                    quality: 90
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shopCard_module_default()).shopLogo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopLogo, {
                    data: data
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shopCard_module_default()).body,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopBadges, {
                        data: data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shopCard_module_default()).titleContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "".concat((shopCard_module_default()).title, " ").concat(!(data === null || data === void 0 ? void 0 : data.verify) && (shopCard_module_default()).maxWidth),
                                children: (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title
                            }),
                            !!(data === null || data === void 0 ? void 0 : data.verify) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedComponent, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (shopCard_module_default()).text,
                        children: !isShopClosed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                workingSchedule === null || workingSchedule === void 0 ? void 0 : workingSchedule.from,
                                " - ",
                                workingSchedule === null || workingSchedule === void 0 ? void 0 : workingSchedule.to
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("closed")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shopCard_module_default()).rating,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                value: (data === null || data === void 0 ? void 0 : data.r_avg) || 0,
                                readOnly: true,
                                size: "small",
                                precision: 0.5,
                                name: "ratingIcon",
                                color: "var(--orange)",
                                className: (shopCard_module_default()).ratingIcon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (shopCard_module_default()).ratingCount,
                                children: (data === null || data === void 0 ? void 0 : data.r_count) || 0
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
// EXTERNAL MODULE: ./components/button/load-more.tsx
var load_more = __webpack_require__(763);
// EXTERNAL MODULE: ./components/empty/empty.tsx
var empty = __webpack_require__(9956);
;// CONCATENATED MODULE: ./containers/shopList/shopList.tsx








function ShopList(param) {
    let { title , shops , loading , fetchNextPage , hasNextPage =false , fetchingNextPage =false  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width:1140px)");
    const handleLoadNexPage = ()=>{
        if (hasNextPage && fetchNextPage) {
            fetchNextPage();
        }
    };
    if (!loading && !(shops === null || shops === void 0 ? void 0 : shops.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(empty["default"], {
            text: t("no.shops.found")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (shopList_module_default()).container,
        style: {
            display: !loading && shops.length === 0 ? "none" : "block"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shopList_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shopList_module_default()).header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (shopList_module_default()).title,
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: isDesktop ? 4 : 2,
                    children: !loading ? shops.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopCard, {
                                data: item
                            })
                        }, item.id)) : Array.from(new Array(4)).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "rectangular",
                                className: (shopList_module_default()).shimmer
                            })
                        }, "shops" + idx))
                }),
                hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shopList_module_default()).loadMore,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(load_more/* default */.Z, {
                        loading: fetchingNextPage,
                        onClick: handleLoadNexPage,
                        children: t("load.more")
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 40079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShopWorkingSchedule; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51218);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_weekdays__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85794);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28719);




function useShopWorkingSchedule(data) {
    const { order  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.order);
    const { workingSchedule , isShopClosed , isOpen , isTodayDisabled  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        var ref, ref1;
        const isSelectedDeliveryDate = order.shop_id === (data === null || data === void 0 ? void 0 : data.id) && !!order.delivery_date;
        const today = isSelectedDeliveryDate ? order.delivery_date : dayjs__WEBPACK_IMPORTED_MODULE_1___default()().format("YYYY-MM-DD");
        const weekDay = constants_weekdays__WEBPACK_IMPORTED_MODULE_3__/* .WEEK */ .p[isSelectedDeliveryDate ? dayjs__WEBPACK_IMPORTED_MODULE_1___default()(order.delivery_date).day() : dayjs__WEBPACK_IMPORTED_MODULE_1___default()().day()];
        const foundedSchedule = data === null || data === void 0 ? void 0 : (ref = data.shop_working_days) === null || ref === void 0 ? void 0 : ref.find((item)=>item.day === weekDay);
        const isHoliday = data === null || data === void 0 ? void 0 : (ref1 = data.shop_closed_date) === null || ref1 === void 0 ? void 0 : ref1.some((item)=>dayjs__WEBPACK_IMPORTED_MODULE_1___default()(item.day).isSame(isSelectedDeliveryDate ? dayjs__WEBPACK_IMPORTED_MODULE_1___default()(order.delivery_date) : dayjs__WEBPACK_IMPORTED_MODULE_1___default()()));
        const isClosed = !(data === null || data === void 0 ? void 0 : data.open) || isHoliday;
        let schedule = {};
        let isTimePassed = false;
        let isTimeDidNotStart = false;
        try {
            if (foundedSchedule) {
                schedule = {
                    ...foundedSchedule
                };
                schedule.from = schedule.from.replace("-", ":");
                schedule.to = schedule.to.replace("-", ":");
                isTimePassed = dayjs__WEBPACK_IMPORTED_MODULE_1___default()().isAfter("".concat(today, " ").concat(schedule.to));
                isTimeDidNotStart = dayjs__WEBPACK_IMPORTED_MODULE_1___default()().isBefore("".concat(today, " ").concat(schedule.from));
            }
        } catch (err) {
            console.log("err => ", err);
        }
        return {
            workingSchedule: schedule,
            isShopClosed: schedule.disabled || isClosed || isTimePassed || isTimeDidNotStart,
            isOpen: Boolean(data === null || data === void 0 ? void 0 : data.open),
            isTodayDisabled: schedule.disabled
        };
    }, [
        data,
        order.delivery_date,
        order.shop_id
    ]);
    return {
        workingSchedule,
        isShopClosed,
        isOpen,
        isTodayDisabled
    };
}


/***/ }),

/***/ 7592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getImage; }
/* harmony export */ });
// import { IMAGE_URL } from "constants/constants";
function getImage(img) {
    if (img) {
        return img;
    } else {
        return "";
    }
}


/***/ }),

/***/ 30730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__BHeKC","default":"badge_default__18BvY","circle":"badge_circle__mQVZ_","text":"badge_text__cdsyf","large":"badge_large__bhCOW","medium":"badge_medium__3BTPx","bonus":"badge_bonus__Ice67","discount":"badge_discount__gVAeQ","popular":"badge_popular__ywwJB"};

/***/ }),

/***/ 55684:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"empty_wrapper__nwTin","text":"empty_text__oRHIv","actions":"empty_actions__NNcWA"};

/***/ }),

/***/ 79963:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"fallbackImage_root__7qEqB"};

/***/ }),

/***/ 79059:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"shopCard_wrapper__eLDR6","header":"shopCard_header__ndTnF","shopLogo":"shopCard_shopLogo__YBVUk","body":"shopCard_body__RaioU","titleContainer":"shopCard_titleContainer__PoAO_","title":"shopCard_title__ZOeFL","maxWidth":"shopCard_maxWidth__hzAq9","text":"shopCard_text__N8BjM","rating":"shopCard_rating__e7b0N","ratingIcon":"shopCard_ratingIcon___i8oO","ratingCount":"shopCard_ratingCount__okJy2"};

/***/ }),

/***/ 66944:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"shopLogo_logo__RFCaX"};

/***/ }),

/***/ 97950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"shopBadges_badge__NpYKe"};

/***/ }),

/***/ 88090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"shopList_container__dXd4J","wrapper":"shopList_wrapper__q4bQb","header":"shopList_header__8uPMd","title":"shopList_title__D3BSf","loadMore":"shopList_loadMore__xxuRm","shimmer":"shopList_shimmer__tOM85"};

/***/ })

}]);